<template>
  <div>

    <Dialog :visible.sync="exibirModalNovo" header="Editar Marcações" :modal="true" :style="{width: '55vw'}" @hide="fecharModal">        
        <TabView>
            <TabPanel header="Marcações REP/Pré-assinaldas" class="p-mt-3">                 
                <DataTable :value="marcacoesREPP" :autoLayout="true" class="p-datatable-sm p-datatable-striped">           
                    <Column field="descartado" header="Descartado">    
                        <template #body="slotProps">
                            <Checkbox v-model="slotProps.data.descartado" :binary="true"/>
                        </template> 
                    </Column>          
                    <Column field="data" header="Data"></Column> 
                    <Column field="hora" header="Hora"></Column> 
                    <Column field="fonte" header="Fonte"></Column> 
                    <Column field="idJustificativa" header="Justificativa">                    
                        <template #body="slotProps">                           
                            <Dropdown v-model="idsJustificativasREPP[slotProps.data.index].id" :options="justificativas"   
                                        optionLabel="descricao" optionValue="id" placeholder="Selecione" appendTo="body" 
                                        @change="selecionarJustificativa(slotProps.data, 'REPP')"/>
                        </template>                    
                    </Column>           
                </DataTable>
            </TabPanel>
            <TabPanel header="Marcaçõse Inseridas" class="p-mt-3">
                <DataTable :value="marcacoesInseridas" :autoLayout="true" class="p-datatable-sm p-datatable-striped">           
                    <Column field="descartado" header="Excluir">    
                        <template #body="slotProps">
                            <Checkbox v-model="slotProps.data.descartado" :binary="true" :disabled="slotProps.data.id == null"/>
                        </template> 
                    </Column> 
                    <Column field="novo" header="Novo">    
                        <template #body="slotProps">
                            <Checkbox v-model="slotProps.data.nova" :binary="true" :disabled="slotProps.data.id != null"/>
                        </template> 
                    </Column>          
                    <Column field="data" header="Data">
                        <template #body="slotProps">
                            <Calendar v-model="slotProps.data.data" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" appendTo="body"/>
                        </template>
                    </Column> 
                    <Column field="hora" header="Hora">
                        <template #body="slotProps">
                            <InputText v-model="slotProps.data.hora" maxlength="5" placeholder=":" class="p-text-center" 
                                @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(slotProps.data)"/>
                        </template>
                    </Column> 
                    <Column field="fonte" header="Fonte"></Column> 
                    <Column field="idJustificativa" header="Justificativa">
                        <template #body="slotProps">
                            <Dropdown v-model="idsJustificativasInseridas[slotProps.data.index].id" :options="justificativas" 
                                        optionLabel="descricao" optionValue="id" placeholder="Selecione" appendTo="body" 
                                        @change="selecionarJustificativa(slotProps.data, 'I')"/>
                        </template>                    
                    </Column>           
                </DataTable>
            </TabPanel>
        </TabView>	
        <template #footer>
            <div class="p-d-flex p-jc-between">
                <h6 class="p-text-bold">Marcações do dia {{ dataPonto }}</h6>
                <div>
                    <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
                    <Button label="Salvar" icon="pi pi-check" @click="salvar" />
                </div>                              
            </div>            
        </template>        
    </Dialog>
  </div>
</template>

<script>
import ControlePontoService from '@/service/ControlePontoService';
import { exibirMensagem, exibirMensagemSis, formatarEtradaHora } from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    props: {
        callback: Function,
    },
    data() {
        return {
            idsJustificativasREPP: [],
            idsJustificativasInseridas: [],
            marcacoesREPP: [],
            marcacoesInseridas: [],            
            dataPonto: null,
            exibirModalNovo: false,          
            justificativas: [],
            requisicao: {},
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        processar(req) {   
            this.requisicao = {...req};     
            this.dataPonto = this.formatarStringData(req.dataPonto);                
            this.controlePontoService.listarMarcacoesEditar(req)
            .then(resp => {
                this.marcacoesREPP = resp.data.marcacoesREPP;
                this.marcacoesInseridas = resp.data.marcacoesInseridas;           
                this.marcacoesREPP.forEach((marcacao, i) => { 
                    marcacao.data = this.formatarStringData(marcacao.data);                   
                    marcacao['index'] = i;
                    if(marcacao.justificativa != null) {
                        this.idsJustificativasREPP.push({id: marcacao.justificativa.id});
                    } else {
                        this.idsJustificativasREPP.push({id: null});
                    }                  
                });
                this.marcacoesInseridas.forEach((marcacao, i) => {
                    marcacao.data = this.formatarStringData(marcacao.data); 
                    marcacao['index'] = i;
                    if(marcacao.justificativa != null) {
                        this.idsJustificativasInseridas.push({id: marcacao.justificativa.id});
                    } else {
                        this.idsJustificativasInseridas.push({id: null});
                    }                    
                });                
                let vazio = {
                    descricao: 'Selecione',
                    id: null
                }
                this.justificativas.push(vazio);
                Array.prototype.push.apply(this.justificativas, resp.data.justificativas);                
                this.exibirModalNovo = true;
            })
            .catch(erro => {exibirMensagem(this, erro)});            
        },      
        salvar() {   
            if(!this.requisicao.idPonto) {
                exibirMensagemSis(this, 'Nenhum ponto selecionado.', true);
                return;
            }
            this.requisicao['marcacoesREPP'] = [];            
            this.requisicao['marcacoesInseridas'] = [];   
            let erro = false;
            for(let i = 0; i < this.marcacoesREPP.length; i++) {
                let marc = {...this.marcacoesREPP[i]};
                marc.data = this.formatarData(marc.data);               
                if(marc.descartado && marc.justificativa && !marc.justificativa.id) {
                    exibirMensagemSis(this, 'Selecione uma justificativa para descartar a marcação do REP.', true);
                    erro = true;
                    break;
                }
                if(marc.justificativa) {
                    if(!marc.justificativa.id || marc.justificativa.descricao == 'Selecione') {
                        marc.justificativa = null;
                    }                    
                }
                this.requisicao.marcacoesREPP.push(marc);
            }
            if(erro) {
                return;
            }
            for(let i = 0; i < this.marcacoesInseridas.length; i++) {
                let marc = {...this.marcacoesInseridas[i]};
                marc.data = this.formatarData(marc.data);                
                if(marc.nova && marc.justificativa && !marc.justificativa.id) {
                    exibirMensagemSis(this, 'Selecione uma justificativa para cada marcação inserida.', true);
                    erro = true;
                    break;
                }
                if(marc.justificativa) {
                    if(!marc.justificativa.id || marc.justificativa.descricao == 'Selecione') {
                        marc.justificativa = null;
                    }                    
                }
                if(marc.hora) {
                    let partesHora = marc.hora.split(':');
                    if(partesHora.length != 2) {
                        marc.hora = null;
                    } else {
                        if(isNaN(Number(partesHora[0])) || isNaN(Number(partesHora[1]))) {
                            marc.hora = null;
                        } else if(Number(partesHora[0]) > 23 || Number(partesHora[1]) > 59) {
                            marc.hora = null;
                        }
                    }                    
                }
                this.requisicao.marcacoesInseridas.push(marc);
            }
            if(erro) {
                return;
            }
            this.controlePontoService.salvarMarcacoesEditar(this.requisicao)
            .then(resp => {
                exibirMensagem(this, resp);		
                this.callback(this.formatarData(this.dataPonto), this.formatarData(this.dataPonto));
                this.fecharModal(); 
            })
            .catch(erro => {                
                exibirMensagem(this, erro)
            });   
        },
        selecionarJustificativa(marcacao, tipo) {   
            let idsJustificativas = tipo == 'REPP' ? this.idsJustificativasREPP : this.idsJustificativasInseridas;         
            this.justificativas.forEach(justificativa => {
                if(idsJustificativas[marcacao.index].id == justificativa.id) {
                    marcacao.justificativa = justificativa;
                }
            });
        },
        limparEntradaHoraInvalida(marcacao) {           
            if(marcacao.hora == null) {
                return;
            }
            let regex = /[0-2][0-9]:[0-5][0-9]/g;
            if(!marcacao.hora.match(regex)) {
                marcacao.hora = '';
            }
        },
        validarEntraHora(event) {
            formatarEtradaHora(event);
        },
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        formatarStringData(data) {
            if(!data || data instanceof Date) {
                return '';
            } 
            let partes = data.split('-');
            return partes[2] + '/' + partes[1] + '/' + partes[0];
        },        
        fecharModal() {
            this.idsJustificativasREPP = [];
            this.idsJustificativasInseridas = [];
            this.requisicao = {};
            this.exibirModalNovo = null;    
            this.marcacoesREPP = [];
            this.marcacoesInseridas = [];
            this.justificativas = [];            
        }
    },
    created() {
        this.controlePontoService = new ControlePontoService();
    },
}
</script>

<style>

</style>